module.exports = window.Highcharts;
